import * as React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonIcon from "@mui/icons-material/Person";
import BookmarksIcon from "@mui/icons-material/Bookmarks";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import FavoriteIcon from "@mui/icons-material/Favorite";
import HistoryIcon from "@mui/icons-material/History";
import ImportContactsIcon from "@mui/icons-material/ImportContacts";
import ListIcon from '@mui/icons-material/List';
import CollectionsBookmarkIcon from "@mui/icons-material/CollectionsBookmark";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import UploadIcon from "@mui/icons-material/Upload";
import QuizIcon from "@mui/icons-material/Quiz";
import { Navigate } from "react-router-dom";
import { Button } from "@mui/material";

export const mainListItems = [
  //   {
  //     name: "Dashboard",
  //     item: (
  //       <ListItemButton>
  //         <ListItemIcon>
  //           <DashboardIcon />
  //         </ListItemIcon>
  //         <ListItemText primary="Dashboard" />
  //       </ListItemButton>
  //     ),
  //   },
  /*
    {
        name: 'Favorite',
        item: <ListItemButton >
            <ListItemIcon>
                <FavoriteIcon />
            </ListItemIcon>
            <ListItemText primary="Favorite" />
        </ListItemButton>
    }
    ,
    {
        name: 'History',
        item: <ListItemButton>
            <ListItemIcon>
                <HistoryIcon />
            </ListItemIcon>
            <ListItemText primary="History" />
        </ListItemButton>
    }
    */
  {
    name: "Account",
    item: (
      <ListItemButton>
        <ListItemIcon>
          <PersonIcon />
        </ListItemIcon>
        <ListItemText
          primary="アカウント"
          sx={{
            whiteSpace: "nowrap",
          }}
        />
      </ListItemButton>
    ),
  },
  // {
  //   name: "Favorite",
  //   item: (
  //     <ListItemButton>
  //       <ListItemIcon>
  //         <BookmarksIcon />
  //       </ListItemIcon>
  //       <ListItemText
  //         primary="お気に入り"
  //         sx={{
  //           whiteSpace: "nowrap",
  //         }}
  //       />
  //     </ListItemButton>
  //   ),
  // },
  {
    name: "Good",
    item: (
      <ListItemButton>
        <ListItemIcon>
          <ThumbUpAltIcon />
        </ListItemIcon>
        <ListItemText
          primary="いいね"
          sx={{
            whiteSpace: "nowrap",
          }}
        />
      </ListItemButton>
    ),
  },
  {
    name: "History",
    item: (
      <ListItemButton>
        <ListItemIcon>
          <HistoryIcon />
        </ListItemIcon>
        <ListItemText
          primary="閲覧履歴"
          sx={{
            whiteSpace: "nowrap",
          }}
        />
      </ListItemButton>
    ),
  },
];
export const subListItems = [
  {
    name: "MStudy",
    auths: ["admin", "edit"],
    item: (
      <ListItemButton>
        <ListItemIcon>
          <QuizIcon />
        </ListItemIcon>
        <ListItemText
          primary="M-Study"
          sx={{
            whiteSpace: "nowrap",
          }}
        />
      </ListItemButton>
    ),
  },
  {
    name: "Catalogue",
    auths: ["admin", "edit"],
    item: (
      <ListItemButton>
        <ListItemIcon>
          <CollectionsBookmarkIcon />
        </ListItemIcon>
        <ListItemText primary="Catalogue" />
      </ListItemButton>
    ),
  },
  {
    name: "Search",
    auths: ["admin", "edit"],
    item: (
      <ListItemButton>
        <ListItemIcon>
          <ListIcon />
        </ListItemIcon>
        <ListItemText primary="疾患一覧" 
        sx={{
          whiteSpace: "nowrap",
        }}/>
      </ListItemButton>
    ),
  },
  {
    name: "User",
    auths: ["admin"],
    item: (
      <ListItemButton>
        <ListItemIcon>
          <ManageAccountsIcon />
        </ListItemIcon>
        <ListItemText primary="User" />
      </ListItemButton>
    ),
  },
  /*
    {
        name: 'Upload',
        item: <ListItemButton >
            <ListItemIcon>
                <UploadIcon />
            </ListItemIcon>
            <ListItemText primary="Upload" />
        </ListItemButton>
    },
    {
        name: 'DiseaseUpload',
        item: <ListItemButton >
            <ListItemIcon>
                <UploadIcon style={{ color: 'pink' }} />
            </ListItemIcon>
            <ListItemText primary="DiseaseUpload" />
        </ListItemButton>
    }
    */
];
